<template>
  <v-container>
      <v-dialog v-model="openFlag" max-width="600px" persistent>
      <c-card class="white" title="일괄등록">
        <v-row>
          <v-row justify="start" align="center">
            <v-col cols="8">
              <v-select
                :disabled="progressFlag"
                v-model="uploadType"
                :items="uploadTarget === '차량'? [{text: '신규등록', value: 'new'}] : [{text: '신규등록', value: 'new'}, {text: '업데이트', value: 'update'}]"
                solo dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" style="margin-top: -20px">
            <div v-if="uploadType === 'new'">기존에 등록되지 않았던 {{uploadTarget}}들의 정보를 등록합니다.</div>
            <div v-else>기존에 등록되었던 {{uploadTarget}}들의 정보를 갱신합니다.</div>
            <v-col cols="12">
              <v-file-input
                :disabled="progressFlag"
                clearable small-chips show-size
                label="클릭하여 파일을 등록해주세요."
                v-model="file"
                @change="inputFile" accept=".xlsx, .xls," ref="inputFileRef"></v-file-input>
            </v-col>
            <c-btn class="blue mr-2" @click="bulkRegist" :disabled="progressFlag">등록</c-btn>
            <c-btn color="blue" outlined @click="openFlag = false" :disabled="progressFlag">취소</c-btn>
          </v-row>
        </v-row>
      </c-card>
      <div class="loading_wrapper">
        <div class="loading" v-show="progressFlag">
          <v-progress-circular
            :size="60"
            :width="4"
            color="blue"
            indeterminate />
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      uploadTarget: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        file: [],
        openFlag: false,
        uploadType: 'new',
        progressFlag: false,
      }
    },
    methods: {
      inputFile(event) {
        this.file = event;
      },
      bulkRegist() {
        if ( this.file && this.file.size ) {
          const formData = new FormData();
          formData.append('file', this.file);
          formData.append('uploadType', this.uploadType)
          this.$emit('fileData', formData);
          this.progressFlag = true;
        } else {
          this.$store.commit('snackbar', {color: 'red', msg:'첨부 파일이 없습니다. 파일을 업로드해주세요.'});
        }
      },
    },
    watch: {
      open(newVal) {
        this.openFlag = newVal;
      },
      openFlag(newVal) {
        if(newVal) {
          this.file = null;
          if(this.$refs.inputFileRef && this.$refs.inputFileRef.value) this.$refs.inputFileRef.value = "";
          this.uploadType = 'new';
        } else {
          this.progressFlag = false;
          this.$emit('update:open', false);
        }
      }
    },
  }
</script>
<style scoped>
  .loading_wrapper {
    position: absolute;
  }
  .loading {
    text-align: center;
    position: absolute;
    color: #fff;
    z-index: 9;
    border-radius: 5px;
    left: 280px;
    bottom: 110px;
    /*top: calc(50% - 18px);*/
  }
</style>
